// // Graph.js
// import React from 'react';
// import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceLine, ResponsiveContainer } from 'recharts';

// const Graph = ({ data, dataKey, xRef, yRef, color, gradientId }) => {
//   return (
//     <ResponsiveContainer width="70%" height="90%"  style={{ marginTop: '20px',marginLeft:'25px' }}>
//       <AreaChart data={data}>
//         <defs>
//           <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
//             <stop offset="0%" stopColor={color} stopOpacity={0.6} />
//             <stop offset="100%" stopColor={color} stopOpacity={0} />
//           </linearGradient>
//         </defs>
//         <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
//         <XAxis dataKey="month" axisLine={false} tickLine={false}   tick={{ fontSize: 10.74, fill: '#718EBF',fontWeight: '400' }}  />
//         <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 10.74, fill: '#718EBF',fontWeight: '400' }}/>
//         <Tooltip  cursor={{ stroke: 'gray', strokeWidth: 1 }}
//         contentStyle={{
//           backgroundColor: 'red',
//           borderRadius: '8px',
//           color: '#fff',
//           width: '60px',
//           height: '40px',
//           // display: 'flex',
//           // justifyContent: 'center',
//           // alignItems: 'center',
//           // textAlign: 'center',
//         }}
//         itemStyle={{
//           color: 'black',
//           fontSize: '10px',
//         }} />
//         {xRef && <ReferenceLine x={xRef} stroke="red" strokeDasharray="5 5" />}
//         {yRef && <ReferenceLine y={yRef} stroke="red" />}
//         <Area
//           type="monotone"
//           dataKey={dataKey}
//           stroke={color}
//           fill={`url(#${gradientId})`}
//           strokeWidth={2}
//           dot={false}
//           activeDot={{ r: 8 }}
//         />
//       </AreaChart>
//     </ResponsiveContainer>
//   );
// };

// export default Graph;

import React, { useState } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceLine,
  ResponsiveContainer,
} from "recharts";

const CustomTooltip = ({ active, payload, xAxisValue, setHoveredValues }) => {
  if (active && payload && payload.length) {
    const yAxisValue = payload[0].value;
    // console.log(yAxisValue);

    setHoveredValues({ xAxisValue, yAxisValue });
    return (
      <div
        style={{
          backgroundColor: "#F64E60",
          color: "white",
          padding: "8px",
          borderRadius: "7.11px",
          fontSize: "10px",
          textAlign: "center",
          width: "39.41px",
          height: "28.72px",
        }}
      >
        <p style={{ marginTop: "-2px", fontWeight: "600" }}>{yAxisValue}</p>
      </div>
    );
  }

  setHoveredValues(null);
  return null;
};

const Graph = ({
  data,
  dataKey,
  color,
  gradientId,
  width = "100%",
  height = "100%",
  style = {},
  yAxisProps,
  medianValue,
}) => {
  const [hoveredValues, setHoveredValues] = useState(null);

  return (
    <ResponsiveContainer width={width} height={height} style={style}>
      <AreaChart data={data}>
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity={0.6} />
            <stop offset="100%" stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#DFE5EE" />
        <XAxis
          dataKey="range"
          axisLine={false}
          tickLine={false}
          // tick={{ fontSize: 9, fill: '#718EBF', fontWeight: '400' }}
          tick={false} // Disables tick labels
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          tick={{ fontSize: 10.74, fill: "#718EBF", fontWeight: "400" }}
          {...yAxisProps} // Apply Y-axis props

        // ticks={[0,1,2,3,4,5,6,7,8,9,10]}
        // ticks={[0,2,4,6,8,10]}

        // interval={0} // Ensures all ticks are shown
        // dataKey="Avg"
        />
        <Tooltip
          cursor={{ stroke: "gray", strokeWidth: 1 }}
          content={({ active, payload, label }) => (
            <CustomTooltip
              active={active}
              payload={payload}
              xAxisValue={label}
              setHoveredValues={setHoveredValues}
            />
          )}
        />
        {/* {hoveredValues && (
          <>
            <ReferenceLine x={hoveredValues.xAxisValue} stroke="red" strokeDasharray="3 3" />
            <ReferenceLine y={hoveredValues.yAxisValue} stroke="red" />
          </>
        )} */}
        {/* Add a ReferenceLine for the median */}
        {medianValue && (
          <ReferenceLine
            y={medianValue}
            stroke="#FF5722"
            strokeWidth={2}
            label={{
              value: `${dataKey === "customerSatisfaction"
                  ? `Median: ${medianValue}`
                  : `Average: ${medianValue} %`
                }`,
              position:
                medianValue > 100 ? "insideTopRight" : "insideBottomRight",
              style: { fill: "#FF5722", fontSize: "12px", fontWeight: "bold" },
            }}
          />
        )}

        {/* ReferenceLine for the X-axis median */}
        {medianValue && (
          <ReferenceLine
            x={medianValue}
            stroke="blue"
            strokeDasharray="5 5"
            label={{
              value: `Median X (${medianValue})`,
              position: "top",
              style: { fill: "blue", fontSize: "12px", fontWeight: "bold" },
            }}
          />
        )}

        <Area
          type="monotone"
          dataKey={dataKey}
          stroke={color}
          fill={`url(#${gradientId})`}
          strokeWidth={2}
          dot={false}
          activeDot={{ r: 8 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default Graph;
